import { render, staticRenderFns } from "./DocumentsVaultMobile.vue?vue&type=template&id=e9d1074c&scoped=true&"
import script from "./DocumentsVaultMobile.vue?vue&type=script&lang=js&"
export * from "./DocumentsVaultMobile.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsVaultMobile.vue?vue&type=style&index=0&id=e9d1074c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d1074c",
  null
  
)

export default component.exports